{
  "personal-data-form": {
    "text": {
      "birthday": "Ngày sinh",
      "name": "Tên",
      "surname": "Họ"
    }
  }
}
